import gmx_zMixins         from '../../../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

// Global Drawing Function
import gmx_draw_BoxedSummary  from '../../../../../../../../includes/mixins/draw_BoxedSummary.mixin'
// Global Event-Call Handlers
import gmx_event_callHandlers from '../../../../../../../../includes/mixins/event_callHandlers.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins
    gmx_draw_BoxedSummary,
    gmx_event_callHandlers,
  ],
}
